<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('backup.backup')}}
                            <span class="card-subtitle" v-if="backups">{{trans('general.total_result_found',{'count' : backups.total})}}</span>
                            <span class="card-subtitle" v-else>{{trans('general.no_result_found')}}</span>
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li class="breadcrumb-item active">{{trans('backup.backup')}}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" @click="$router.push('/home')"><i class="feather icon-home"></i> {{trans('general.home')}}</button>
                    
                </div>
            </div>

        </div>

        <div class="content-body">
            <section>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">{{trans('backup.generate_backup')}}</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                    <show-tip module="backup" tip="tip_backup"></show-tip>
                                        <div class="form-group">
                                            <switches class="m-l-20" v-model="backupForm.delete_previous" theme="bootstrap" color="success"></switches> {{trans('backup.delete_previous_backup?')}} <show-tip module="backup" tip="tip_delete_previous_backup" type="field"></show-tip>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-primary mr-1 mb-1 waves-effect waves-light" @click.prevent="createBackup">{{trans('backup.generate_backup')}}</button>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                        <div class="card-header">
                            <h4 v-if="backups.total" class="card-title">
                                <sort-by class="pull-right" :order-by-options="orderByOptions" :sort-by="filterBackupsForm.sort_by" :order="filterBackupsForm.order" @updateSortBy="value => {filterBackupsForm.sort_by = value}"  @updateOrder="value => {filterBackupsForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="backups.total">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>{{trans('backup.name')}}</th>
                                                <th>{{trans('backup.generated_at')}}</th>
                                                <th class="table-option">{{trans('general.action')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="backup in backups.data">
                                                <td v-text="backup.file"></td>
                                                <td>{{backup.created_at | momentDateTime }}</td>
                                                <td class="table-option">
                                                    <div class="btn-group">
                                                        <a :href="getDownloadLink(backup)" class="btn btn-success btn-sm" v-tooltip="'Download'"><i class="feather icon-download"></i></a>
                                                        <button class="btn btn-danger btn-sm" :key="backup.id" v-confirm="{ok: confirmDelete(backup)}" v-tooltip="'Delete Backup'"><i class="feather icon-trash-2"></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <module-info v-if="!backups.total" module="backup" title="module_info_title" description="module_info_description" icon="box">
                                </module-info>
                                <pagination-record :page-length.sync="filterBackupsForm.page_length" :records="backups" @updateRecords="getBackups" @change.native="getBackups"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>

            
        </div>

        
    </div>
</template>

<script>
    import sortBy from '../../components/sort-by'
    import switches from 'vue-switches'

    export default {
        components : { switches,sortBy },
        data() {
            return {
                backupForm: new Form({
                    delete_previous: false
                }),
                backups: {
                    total: 0,
                    data: []
                },
                filterBackupsForm: {
                    page_length: helper.getConfig('page_length'),
                    sort_by: 'created_at',
                    order: 'desc'
                },
                orderByOptions: [
                    {
                        value: 'created_at',
                        translation: i18n.general.created_at
                    }
                ]
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('backup')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getBackups();
        },
        methods: {
            createBackup(){
                this.backupForm.post('/api/backup')
                    .then(response => {
                        toastr.success(response.message);
                        this.getBackups();
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    })
            },
            getBackups(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterBackupsForm);
                axios.get('/api/backup?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.backups = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(backup){
                return dialog => this.deleteBackup(backup);
            },
            deleteBackup(backup){
                axios.delete('/api/backup/'+backup.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getBackups();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getDownloadLink(backup){
                return '/backup/'+backup.id+'/download/?token='+localStorage.getItem('auth_token');
            },
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          }
        },
        watch: {
            filterBackupsForm: {
                handler(val){
                    this.getBackups();
                },
                deep: true
            }
        }
    }
</script>
